import { ReactChild, ReactChildren, HTMLAttributes } from 'react';

import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { RED, PRIMARY } from 'constants/colors';

import Checkbox from '@mui/material/Checkbox';

export const optionFontSize = 15;
export const optionPadding = 8;
export const iconMargin = 10;
export const optionHeight = 42;
export const iconWidth = 20 + iconMargin; // ~ 20px (18.56)
export const checkboxWidth = 40;

const MuiAutocompleteOptionStyles = styled.li`
  .left-icon {
    margin-right: ${iconMargin}px;
  }

  &.has-checkbox {
    padding-left: 0 !important;
  }
`;

type Props = {
  isMulti?: boolean;
  selected: boolean;
  label: string;
  children?:
    | ReactChild
    | ReactChild[]
    | ReactChildren
    | ReactChildren[]
    | false;
  isInvalid?: boolean;
  inputValue: string;
} & HTMLAttributes<HTMLLIElement>;

export default function MuiAutocompleteOption({
  isMulti = false,
  selected,
  label,
  children,
  isInvalid,
  inputValue,
  ...rest
}: Props) {
  const { t } = useTranslation('common');
  if (isInvalid) {
    label += ` (${t('invalid').toLowerCase()})`;
  }

  const matches = match(label, inputValue, { insideWords: true });
  const parts = parse(label, matches).map((p) => ({ ...p, id: uuidv4() }));

  return (
    <MuiAutocompleteOptionStyles
      {...rest}
      className={classNames('MuiAutocomplete-option', 'd-flex', {
        'has-checkbox': isMulti
      })}
    >
      {isMulti && <Checkbox checked={selected} />}
      {children}
      <div style={isInvalid ? { color: RED } : undefined}>
        {parts.map((part) => (
          <span
            key={part.id}
            style={{
              color: part.highlight ? PRIMARY : 'inherit'
            }}
          >
            {part.text}
          </span>
        ))}
      </div>
    </MuiAutocompleteOptionStyles>
  );
}
